// Regras de horas e receita usadas pelas telas de Relatórios e pelo assistente.
// Sem imports: o mesmo arquivo roda no Vite e no Deno.

export interface EntryTimes {
  duration: number | null; // minutos
  start_time: string | null;
  end_time: string | null;
}

export function entryHours(e: EntryTimes): number {
  let hours = 0;
  if (e.duration) {
    hours = e.duration / 60;
  } else if (e.start_time && e.end_time) {
    hours = (new Date(e.end_time).getTime() - new Date(e.start_time).getTime()) / (1000 * 60 * 60);
  }
  return hours > 0 ? hours : 0;
}

// Data AAAA-MM-DD do instante no fuso dado (a Edge Function roda em UTC).
export function dateInTimeZone(iso: string, timeZone: string): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' })
    .format(new Date(iso));
}

// Receita = horas faturáveis × tarifa de venda do CARGO de quem lançou
// (get_role_sale_rates). Quem não tem cargo, ou tem cargo sem tarifa, entra
// pela média ponderada da organização; sem média, a hora fica sem valor.

export interface SaleRateTable {
  rateByUser: Map<string, number>; // auth_id -> R$/h do cargo
  averageRate: number | null;
}

export interface RevenueEntry {
  user_id: string;
  hours: number;
  billable: boolean;
}

export interface RevenueResult {
  revenue: number;
  averagedHours: number; // faturáveis valoradas pela média (sem cargo/tarifa)
  unpricedHours: number; // faturáveis sem nenhum valor
}

export function rateFor(table: SaleRateTable, userId: string): { rate: number; averaged: boolean } | null {
  const own = table.rateByUser.get(userId);
  if (own !== undefined) return { rate: own, averaged: false };
  if (table.averageRate !== null) return { rate: table.averageRate, averaged: true };
  return null;
}

export function computeRevenue(entries: RevenueEntry[], table: SaleRateTable): RevenueResult {
  const result: RevenueResult = { revenue: 0, averagedHours: 0, unpricedHours: 0 };
  for (const entry of entries) {
    if (!entry.billable || entry.hours <= 0) continue;
    const found = rateFor(table, entry.user_id);
    if (!found) {
      result.unpricedHours += entry.hours;
      continue;
    }
    result.revenue += entry.hours * found.rate;
    if (found.averaged) result.averagedHours += entry.hours;
  }
  return result;
}
